import { Component, ElementRef, ViewChild, Output, EventEmitter } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { MovementType, TipoDeMovimiento } from '../../../../../models/MovementType';
import { MovementVM } from '../../../../../models/view-models';
import { ShiftService } from '../../../../../services/shift.service';

@Component({
  selector: 'modal-cash-in',
  templateUrl: './cash-in.component.html',
  styleUrls: ['./cash-in.component.scss']
})
export class CashInComponent {

  showDialog: boolean = false;
  dialogForm: FormGroup;
  movement: MovementVM;
  @ViewChild("amount") amount: ElementRef;
  @ViewChild('conceptInput') conceptInput: ElementRef;
  @ViewChild('saveButton') saveButton: ElementRef;

  @Output() cashInEmiter: EventEmitter<MovementVM> = new EventEmitter<MovementVM>();
  @Output() modalClose: EventEmitter<any> = new EventEmitter<any>();

  userId: string = "";
  username: string = "";

  constructor(private shiftService: ShiftService,
    private fb: FormBuilder) { }

  initForm() {
    this.dialogForm = this.fb.group({
      Amount: ['', [Validators.required]],
      Concept: ['']
    });
  }

  focusOnAmountInput() {
    setTimeout(() => {
      this.amount.nativeElement.focus();
    }, 0);
  }

  isValidForm(): boolean { return this.dialogForm.valid; }

  public openDialog(user_id: string, username: string) {
    this.userId = user_id;
    this.username = username;
    this.showDialog = true;
    this.initForm();

    this.focusOnAmountInput();
  }

  createMovement() {
    if (this.isValidForm()) {
      this.movement = Object.assign({
        UserId: this.userId,
        UserName: this.username,
        MovementType: MovementType.CASH_IN,
        MovementTypeName: TipoDeMovimiento.I,
        CreateDate: new Date(),
        ShiftId: this.shiftService.getActiveShiftId()
      }, this.dialogForm.value);
      this.cashInEmiter.emit(this.movement);
    }
  }

  closeDialog() {
    this.showDialog = false;
    this.modalClose.emit();
  }

  conceptFocus(event: KeyboardEvent) {
    event.preventDefault();
    setTimeout(() => {
      this.conceptInput.nativeElement.focus();
    }, 0);
  }

  saveFocus(event: KeyboardEvent) {
    event.preventDefault();
    setTimeout(() => {
      this.saveButton.nativeElement.focus();
    }, 0);
  }



}
